module.exports = __webpack_public_path__ + "static/img/aboutUs.c98a184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutUs.jpg
// module id = ywJO
// module chunks = 2